<div class="home-header">
  <div class="d-flex justify-content-between mb-3">
    <div>
      <img [src]="logo" alt="Smile Logo" class="home-img" />
      <div class="home-version">
        {{ versionStr }}
      </div>
    </div>
    @if (saveStatus$ | async; as saveStatus) {
      <div>
        @if (showSaveButton$ | async) {
          <button
            class="btn btn-dark mt-1 me-2"
            (click)="saveQr()"
            [disabled]="disableSaveButton$ | async"
          >
            {{ "Home.SaveChanges" | translate }}
          </button>
        } @else {
          <i [ngClass]="saveStatus.iconClass" aria-hidden="true"></i>
          <span class="home-mgn-foot-indicator">{{
            saveStatus.key | translate
          }}</span>
        }
      </div>
    }
  </div>
</div>
<div class="header-margin"></div>
